import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AboutContent from "./components/AboutContent";
function About(){
    return (
        <div>
        <Header/>
        <AboutContent/>
        <Footer/>
        </div>
    )
}

export default About;